<template>
  <div class="publication-picture-slider">
    <Swiper v-bind="settings">
      <SwiperSlide
        v-for="(item,i) in result"
        :key="i"
      >
        <img
          :src="item.src"
          alt="picture-slider"
          class="publication-picture-slider__image"
        >
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue';

export default {
  name: 'PublicationPictureSlider',
  props: ['result'],
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const settings = {
      // spaceBetween: 32,
      // slidesPerView: 3.4,
      centeredSlides: true,
      loop: true,
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 14,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 17,
        },
        1024: {
          spaceBetween: 32,
          slidesPerView: 3.4,
        }
      },
    }

    return {
      settings
    }
  }
}
</script>

<style lang="scss" scoped>
.publication-picture-slider {
  &__image{
    border-radius: 6px;
  }
}
</style>